import { styled, keyframes } from "@mui/material/styles";
import { useDrawingArea, useYScale } from "@mui/x-charts/hooks";

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
`;

const LoadingText = styled("text")(({ theme }) => ({
    stroke: "none",
    fill: theme.palette.text.secondary,
    shapeRendering: "crispEdges",
    textAnchor: "middle",
    dominantBaseline: "middle",
    animation: `${pulse} 3.5s ease-in-out infinite`
}));
const OverlayText = styled("text")(({ theme }) => ({
    stroke: "none",
    fill: theme.palette.text.secondary,
    shapeRendering: "crispEdges",
    textAnchor: "middle",
    dominantBaseline: "middle"
}));

export default function ChartsOverlay({ loading, noData }: { loading?: boolean; noData?: boolean }) {
    const yScale = useYScale();
    const { left, width, height } = useDrawingArea();
    const [, top] = yScale.range();

    if (loading) {
        return (
            <g>
                <LoadingText x={left + width / 2} y={top + height / 2}>
                    Loading data…
                </LoadingText>
            </g>
        );
    }
    if (noData) {
        return (
            <g>
                <OverlayText x={left + width / 2} y={top + height / 2}>
                    No data available
                </OverlayText>
            </g>
        );
    }
    return null;
}
